import React from "react";
import gateLoading from 'assets/img/GateLoading.gif'

export default function Loading({ showLoading = false }) {
  return (
    <div className={`loading-cls ${showLoading && "show_loading"}`}>
      <div className="loading_block">
        <img alt="loading" src={gateLoading} />
      </div>
    </div>
  );
}
